import { render, staticRenderFns } from "./EditarSucursal.vue?vue&type=template&id=6ea4d2b0"
import script from "./EditarSucursal.vue?vue&type=script&lang=js"
export * from "./EditarSucursal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports